<template>
  <div class="attachment">
    <img
      v-if="name != null"
      :src="`data:image/jpeg;base64,${imageSrc}`"
      :id="id"
      :class="['attachment__image', { 'attachment__image--zoomed': isZoomed }]"
      alt="صورة الزيارة المرفقة"
      tabindex="0"
      @click="toggleZoom"
      @keydown.enter.prevent="toggleZoom"
    />

    <b-button v-if="new Date(date) > new Date() || chip == 0" @click="triggerFileInput" variant="outline-primary" class="app-btn app-btn--sm">
      <v-icon small>mdi-paperclip</v-icon>
      أرفق صورة
    </b-button>

    <input type="file" ref="fileInput" :id="`fileInput${id}`" @change="uploadSelectedFile" hidden />
  </div>
</template>

<script>
// Shows the picture attached to a visit and lets the user upload a new one.
export default {
  name: "Attachment",
  props: {
    name: String,
    id: Number,
    imageSrc: String,
    chip: Number,
    date: String,
  },
  data() {
    return {
      isZoomed: false,
    };
  },
  methods: {
    toggleZoom() {
      this.isZoomed = !this.isZoomed;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    uploadSelectedFile() {
      const previewImage = document.getElementById(this.id);
      const file = this.$refs.fileInput.files[0];

      if (!file) {
        previewImage.style.display = "none";
        alert("Please select a valid image file.");
        return;
      }

      // Local preview while the upload is running.
      const reader = new FileReader();
      reader.onload = (e) => {
        previewImage.src = e.target.result;
        previewImage.style.display = "block";
      };
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", this.id);
      this.$http
        .post("/attachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch((error) => {
          console.error("File upload failed:", error);
        });
    },
  },
};
</script>
